
export default class Debounce {
    static #listeners = new WeakMap<
        Element|Window,
        Map<string, EventListenerOrEventListenerObject>
    >();

    static event<K extends keyof HTMLElementEventMap>(
        ev: K,
        selector: string|Window,
        time: number,
        cb: (ev: HTMLElementEventMap[K]) => void
    )
    {
        const nodes = (typeof selector === 'string')
            ? document.querySelectorAll(selector)
            : [selector];

        for (const node of nodes) {
            const perNode = this.#listeners.get(node);
            const existing = perNode?.get(ev);
            if (existing) {
                node.removeEventListener(ev, existing);
            }

            let timeout: ReturnType<typeof setTimeout>;

            const wrapper: EventListener = (e) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => cb(e as HTMLElementEventMap[K]), time);
            };

            node.addEventListener(ev, wrapper);

            const map = perNode ?? new Map();
            map.set(ev, wrapper);
            this.#listeners.set(node, map);
        }
    }
}
